var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfileLogoutIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 21,
    viewBox: "0 0 17 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.10005 1.27895C6.56964 1.27895 5.329 2.51959 5.329 4.05C5.329 5.58041 6.56964 6.82105 8.10005 6.82105C9.63046 6.82105 10.8711 5.58041 10.8711 4.05C10.8711 2.51959 9.63046 1.27895 8.10005 1.27895ZM4.05005 4.05C4.05005 1.81325 5.8633 0 8.10005 0C10.3368 0 12.15 1.81325 12.15 4.05C12.15 6.28675 10.3368 8.1 8.10005 8.1C5.8633 8.1 4.05005 6.28675 4.05005 4.05Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2121 15.2121C11.3293 15.095 11.3293 14.905 11.2121 14.7879L9.30294 12.8787C9.18579 12.7615 8.99584 12.7615 8.87868 12.8787C8.76152 12.9958 8.76152 13.1858 8.87868 13.3029L10.5757 15L8.87868 16.6971C8.76152 16.8142 8.76152 17.0042 8.87868 17.1213C8.99584 17.2385 9.18579 17.2385 9.30294 17.1213L11.2121 15.2121ZM6 15.3H11V14.7H6V15.3Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.45997 11.7118C3.95665 10.5953 5.96571 10.125 8.09541 10.125C10.2251 10.125 12.2362 10.5953 13.735 11.7114C15.2681 12.8531 16.2 14.6249 16.2 17.0315V19.5163C16.2 19.9215 15.8914 20.25 15.5108 20.25H0.689166C0.30855 20.25 0 19.9215 0 19.5163V17.0315C0 14.6257 0.928983 12.8538 2.45997 11.7118ZM3.25092 12.9135C2.10335 13.7695 1.37833 15.0841 1.37833 17.0315V18.7826H14.8217V17.0315C14.8217 15.0849 14.095 13.7703 12.9449 12.9138C11.7606 12.0319 10.0639 11.5924 8.09541 11.5924C6.12686 11.5924 4.4328 12.0319 3.25092 12.9135Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileLogoutIcon);
export default __webpack_public_path__ + "static/media/profile_logout_icon.abe936aa7d7f14f2142e85187b43fed3.svg";
export { ForwardRef as ReactComponent };